import { render, staticRenderFns } from "./LegacyClientsView.vue?vue&type=template&id=80e0418c&"
import script from "./LegacyClientsView.vue?vue&type=script&lang=js&"
export * from "./LegacyClientsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports